import { createSlice } from '@reduxjs/toolkit';
import { asyncIsPending, asyncIsRejected } from '../asyncConfig';
import { getTransactionById, getTransactions, getTransactionsFulfilled } from './transaction_thunk';

const initialState = {
  transactions: [],
  transfer: {
    sender: {},
    receiver: {}
  },
  status: '',
  message: ''
}

export const transactionSlice = createSlice({
  name: 'transactions',
  initialState,
  reducers: {
    clearTransState: (state, action) => {
      state.status = '';
      state.message = '';
      state.transactions = []
    }
  },
  extraReducers: {
    [getTransactions.pending]: asyncIsPending,
    [getTransactions.rejected]: asyncIsRejected,
    [getTransactions.fulfilled]: getTransactionsFulfilled,
    [getTransactionById.pending]: asyncIsPending,
    [getTransactionById.rejected]: asyncIsRejected,
    [getTransactionById.fulfilled]: getTransactionsFulfilled,
  }
});

export const { clearTransState } = transactionSlice.actions; 
export default transactionSlice.reducer;